export default __webpack_public_path__ + "img/4fce475db250883b8b15c4139292b75e.svg";